module.exports = "    <div class=\"tab-loading\">    \r\n        <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active\"  ></div>\r\n    </div>  ";


//////////////////
// WEBPACK FOOTER
// ./app/shared/loading/loading.component.html
// module id = 71
// module chunks = 0